export default __webpack_public_path__ + "static/media/character_thumbail2.b1e114ce.png";